export const ADMIN_AREAS = [
  { path: "/admin", label: "Resumo", permission: "dashboard:read" },
  { path: "/admin/desempenho", label: "Desempenho", permission: "analytics:read" },
  { path: "/admin/catalogo", label: "Catálogo", permission: "catalog:read" },
  { path: "/admin/pedidos", label: "Pedidos", permission: "orders:read" },
  { path: "/admin/clientes", label: "Clientes", permission: "customers:read" },
  { path: "/admin/assinaturas", label: "Assinaturas", permission: "subscriptions:read" },
  { path: "/admin/cupons", label: "Cupons", permission: "catalog:write" },
  { path: "/admin/order-bumps", label: "Order bumps", permission: "catalog:write" },
  { path: "/admin/upsells", label: "Upsells", permission: "catalog:write" },
  { path: "/admin/pre-sells", label: "Pre-sell", permission: "catalog:write" },
  { path: "/admin/cross-sells", label: "Cross-sell", permission: "catalog:write" },
  { path: "/admin/editor-home", label: "Editor da home", permission: "home:editor" },
  { path: "/admin/editor-checkout", label: "Editor do checkout", permission: "checkout:editor" },
  { path: "/admin/emails", label: "E-mails", permission: "settings:manage" },
  { path: "/admin/integracoes", label: "Integrações", permission: "settings:manage" },
  { path: "/admin/webhooks", label: "Webhooks", permission: "webhooks:manage" },
  { path: "/admin/equipe", label: "Equipe", permission: "users:manage" },
  { path: "/admin/auditoria", label: "Auditoria", permission: "audit:read" },
] as const;

export type AdminArea = (typeof ADMIN_AREAS)[number];
export type AdminRoutePermission = AdminArea["permission"];
export type AdminActionPermission =
  | AdminRoutePermission
  | "catalog:delete"
  | "orders:write"
  | "orders:refund"
  | "customers:write"
  | "customers:suspend"
  | "subscriptions:write"
  | "subscriptions:cancel"
  | "finance:read"
  | "finance:write"
  | "finance:refund"
  | "roles:assign";
